import React, { Component } from 'react';

class ResourceNotFound extends Component {
    render() {
        return (
            <React.Fragment>
                <h1>Resource Not Found</h1>
                <p>We were unable to locate the resource you requested.</p>
            </React.Fragment>
        )
    }
}

export default ResourceNotFound;